


















import { ref, defineComponent, inject } from '@vue/composition-api'
import { editVolume } from '@/shared/api'
import VolumeForm from './VolumeForm.vue'
import CloseButton from '@/components/custom/CloseButton.vue'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'EditVolume',
  components: {
    VolumeForm,
    CloseButton,
  },
  props: {
    textbook: Object,
    volume: Object,
  },
  setup(props, context) {
    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const submit = async (formData: { file: string }) => {
      try {
        const data = {
          ...formData,
          volumeId: props.volume.id,
        }
        loading.value = true
        const editedVolume = await editVolume(props.textbook.id, props.volume.id, data)
        context.emit('volume-edited', editedVolume)
        $alert({
          text: context.root.$t('volume.edited'),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      loading,
      submit,
    }
  },
})
